export const InjectEventNames = {
  crm: {
    activities: {
      activityCreated: 'onCrmActivityCreated',
      activityUpdated: 'onCrmActivityUpdated',
      activityDeleted: 'onCrmActivityDeleted',
    },
    flyout: {
      navigateBackward: 'onCrmFlyoutBackwardsNavigate',
      navigateForward: 'onCrmFlyoutForwardsNavigate',
    },
  },
};
